import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { Catalogue } from "@singularsystems/neo-react-services";
import OrganisationEventLookup from "../../../Common/Models/OrganisationEventLookup";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles";
import { AppService, Types } from '../../StaticData/StaticDataTypes';
import OrganisationEventSearchCriteria from '../../../Common/Models/OrganisationEventSearchCriteria';
import OrganisationEvent from '../../../Common/Models/OrganisationEvent';

export default class OrganisationEventPagedCatalogueEntry extends Catalogue.PagedCatalogueEntry<OrganisationEventSearchCriteria, OrganisationEventLookup, OrganisationEvent> {
    
    constructor(private generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        private taskRunner = AppService.get(Types.Neo.TaskRunner)
    ) {
        super("Organisation Events", OrganisationEventSearchCriteria, OrganisationEventLookup, OrganisationEvent, {
            sortBy: "organisationName",
            fetchInitial: true,
            pageSize: 10,
            pageSizeOptions: [10, 20, 50],
        });
    }

    public organisations = this.generalApiClient.getStaticOrganisationList().then((res) => {
        return res.data;
    });

    public staticEvents = this.generalApiClient.getStaticEvents().then((res) => {
        return res.data;
    });

    public get editRole() {
        return Roles.OrganisationConfigurationsRoles.Edit;
    }

    public getPagedDataEndpoint() {
        return this.generalApiClient.getOrganisationEvents;
    }

    public getSaveEndpoint() {
        return this.generalApiClient.saveOrganisationEvent;
    }

    public renderCriteria(criteria: OrganisationEventSearchCriteria, meta: Model.TransformMetaType<OrganisationEventSearchCriteria>) {
        return (
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup label="Organisation Name" bind={meta.organisationName} />
                <Neo.FormGroup label="Event Name" bind={meta.staticEventName} />
            </Neo.GridLayout>
        )
    }

    public renderRow(item: OrganisationEventLookup, meta: Model.TransformMetaType<OrganisationEventLookup>) {
        return (
            <NeoGrid.RowGroup>
                <NeoGrid.Row>
                    <NeoGrid.Column display={meta.organisationName} />
                    <NeoGrid.Column display={meta.staticEventName} />
                    <NeoGrid.ButtonColumn deleteButton={{ onClick: () => this.removeItem(this.taskRunner, item) }} />
                </NeoGrid.Row>
            </NeoGrid.RowGroup>
        );
    }

    public renderFormControls(item: OrganisationEvent, meta: Model.TransformMetaType<OrganisationEvent>) {
        return <div>
            <Neo.GridLayout md={3}>
                <Neo.FormGroup
                    bind={meta.organisationId}
                    select={{ items: this.organisations, displayMember: "organisationName", valueMember: "organisationId" }}>
                </Neo.FormGroup>
                <Neo.FormGroup
                    bind={meta.staticEventId}
                    select={{ items: this.staticEvents, displayMember: "staticEventName", valueMember: "staticEventID" }}>
                </Neo.FormGroup>
            </Neo.GridLayout>
        </div>
    }
}